import $http from '../http'
import { baseUrl } from '../url'
const BASEURL = baseUrl.primary + '/v2'
const BASEURL_DEV = BASEURL + '/Factory'
const customer = {
  PayrollUnitAccountDetail(params) {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/PayrollUnitAccount/Detail`,
      params
    })
  },
 EditCustomerContract(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/EditCustomerContract`,
      data
    })
  },
  PayrollUnitAccountList(params) {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/PayrollUnitAccount/List`,
      params
    })
  },
  FactoryBatchDelete(data) {
    return $http({
      method: 'POST',
      url: `${BASEURL_DEV}/BatchDelete`,
      data
    })
  },
  PayrollUnitAccountDelete(data) {
    return $http({
      method: 'POST',
      url: `${BASEURL_DEV}/PayrollUnitAccount/Delete`,
      data
    })
  },
  PayrollUnitAccountSetDefault(data) {
    return $http({
      method: 'POST',
      url: `${BASEURL_DEV}/PayrollUnitAccount/SetDefault`,
      data
    })
  },
  PayrollUnitAccountEdit(data) {
    return $http({
      method: 'POST',
      url: `${BASEURL_DEV}/PayrollUnitAccount/Edit`,
      data
    })
  },
  PayrollUnitDetail(params) {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/PayrollUnit/Detail`,
      params
    })
  },
  PayrollUnitAccountPage(params) {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/PayrollUnitAccount/Page`,
      params
    })
  },
  PayrollUnitEdit(data) {
    return $http({
      method: 'POST',
      url: `${BASEURL_DEV}/PayrollUnit/Edit`,
      data
    })
  },
  PayrollUnitPage(params) {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/PayrollUnit/Page`,
      params
    })
  },
  PayrollUnitDelete(params) {
    return $http({
      method: 'POST',
      url: `${BASEURL_DEV}/PayrollUnit/Delete`,
      params
    })
  },
  PayrollUnitList(params) {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/PayrollUnit/List`,
      params
    })
  },
  FactoryOneselfFieldChange(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/FactoryOneselfFieldChange`,
      data
    })
  },
  FactoryStatisticsData(params) {
    return $http({
      method: 'GET',
      url: `${BASEURL_DEV}/FactoryStatisticsData`,
      params
    })
  },
  getAllCustomerList(params) {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/List`,
      params
    })
  },
  getCustomerData(params) {
    // 沈帅
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/Page`,
      params
    })
  },

  FactoryManageDelete(id) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Factory/FactoryManageDelete/${id}`
    })
  },

  deleteFactory(id) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Factory/UpdateDeleteState/${id}`
    })
  },

  searchList(data) {
    return $http({
      method: 'get',
      url: `${BASEURL}/Factory/List`,
      data
    })
  },

  sort(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Factory/UpdateSort`,
      data
    })
  },
  getFactoryDetails(id) {
    return $http({
      method: 'get',
      url: `${BASEURL}/Factory/Detail?id=${id}`
    })
  },

  addFactory(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Factory/Edit`,
      data
    })
  },
  addCustomer(data) {
    // 沈帅
    return $http({
      method: 'post',
      url: `${BASEURL}/Edit`,
      data
    })
  },
  getImages(params) {
    // 沈帅
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/ImgPage`,
      params
    })
  },

  FactoryManageEdit(data) {
    // 林家亘
    return $http({
      method: 'POST',
      url: `${BASEURL_DEV}/FactoryManageEdit`,
      data
    })
  },

  FactoryManageListByFactory(params) {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/FactoryManageListByFactory`,
      params
    })
  },

  // 添加单位图册
  addImage(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/ImgEdit`,
      data
    })
  },

  imageSort(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/ImgUpdateSort`,
      data
    })
  },

  changeCustomerLevel(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Customer/EditCustomerLevel?lever=${data.level}`,
      data: data.ids
    })
  },
  getCustomerDetails(id) {
    // 沈帅
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/Detail?id=${id}`
    })
  },
  addCustomerRemark(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Customer/AddCustomerRemark`,
      data
    })
  },
  getCustomerRemark(id) {
    // return $http({
    //   method: "get",
    //   url: `${BASEURL}/Customer/GetCustomerRemark?customerId=${id}`,
    // });
  },
  editCustomerRemark(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Customer/EditCustomerRemark`,
      data
    })
  },
  deleteRemark(id) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Customer/DeleteRemark?remarkId=${id}`
    })
  },
  commitadd() {
    return $http({
      method: 'post',
      url: `${BASEURL}/Factory/ImgEdit`
    })
  },
  imgDelete(id) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/ImgDelete/${id}`
    })
  }
}

export default customer
